var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M3.453 12.367a.8.8 0 0 1 .116-.437.95.95 0 0 1 .32-.32.8.8 0 0 1 .432-.11l6.795-.011.005-6.79a.76.76 0 0 1 .116-.425.95.95 0 0 1 .32-.32.8.8 0 0 1 .431-.122q.244 0 .442.121.2.122.32.32a.8.8 0 0 1 .122.432V11.5l6.79-.006a.74.74 0 0 1 .43.122.9.9 0 0 1 .315.315.9.9 0 0 1 .127.447q0 .232-.121.43a.84.84 0 0 1-.32.321.86.86 0 0 1-.431.122h-6.784l-.006 6.79a.86.86 0 0 1-.127.436.9.9 0 0 1-.315.314.8.8 0 0 1-.43.122.83.83 0 0 1-.443-.122.95.95 0 0 1-.32-.32.8.8 0 0 1-.121-.43l.005-6.79H4.326a.8.8 0 0 1-.43-.122.95.95 0 0 1-.321-.32.83.83 0 0 1-.122-.442"
  })));
};
export default SvgIconPlus;